import { useState, useEffect } from 'react'

export function useMobileDetector(): boolean {
  const [mobileDevice, setMobileDevice] = useState(true)

  useEffect(() => {
    // run in server-render phase in case
    if (!window) {
      return
    }

    const windowInnerWidth = window.innerWidth

    // 1024 from tailwind.config.js
    setMobileDevice(windowInnerWidth <= 1024)
  }, [])

  return mobileDevice
}
